export default {
  inputRange: {
    '& input[type=range]': {
      height: '25px',
      margin: '10px 0',
      width: '100%',
    }
  },
  starPointsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    font: "16px 'Open Sans',sans-serif",
    color: '#cbcaca',
  },
  starPointsSelection:{
    display: 'flex',
    justifyContent: 'flex-end',
    maxWidth: '200px',
    marginLeft: 'auto',
    marginTop: '20px',
    '& button': {
      maxWidth: '100px',
      '& span': {
        display: 'block',
        padding: '5px 0',
      }
    },
  },
  paymentPointsBlock: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '35px',
    '@media (min-width: 801px)': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '55px',
    },
  },
  starTravLogInLogo: {
    width: '40%',
    maxWidth: '103px',
    '@media (min-width: 801px)': {
      width: '30%',
      margin: '0 0 0 20px',
      maxWidth: 'unset',
    },
    '@media (min-width: 801px) and (max-width: 900px)': {
      marginLeft: '0',
    },
    '& > div > div > svg': {
      height: '56px !important',
    }
  },
  checkIcon: {
    fontSize: '15px',
    color: '#5CA70A',
    position: 'relative',
    bottom: '2px',
    left: '4px',
  },
  paymentPointsError: {
    color: '#D0021B',
    fontSize: '13px',
    padding: '15px 10px 0 0',
    '@media (min-width: 801px)': {
      padding: '20px 10px 0 20px',
    },
    '@media (min-width: 801px) and (max-width: 900px)': {
      paddingRight: '20px',
      paddingLeft: '0',
    },
  },
  starPoints: {
    border: '1px solid #cbcaca',
    display: 'flex',
    alignItems: 'center',
    font: "14px 'Open Sans',sans-serif",
    margin: '5px 0',
  },
  paymentPointsContainer: {
    padding: '15px',
    position:'relative',
    '@media (min-width: 801px)': {
      borderBottom: '1px solid #d8d8d8 !important',
      padding: '15px 30px !important',
    },
    '@media (min-width: 801px) and (max-width: 900px)': {
      padding: '15px 15px 15px 30px !important',
    },
  },
  paymentPointsContainerRemaining: {
    borderBottom: 'none !important',
  },
  amountPendingText: {
    font: '300 16px Roboto, sans-serif',
  },
  amountPendingPrice: {
    font: '400 18px Roboto, sans-serif',
    marginLeft: '4px',
  },
  relativeFoldContainer: {
    //paddingRight: '20px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',

    '@media (min-width: 901px)': {
      //paddingRight: '35px',
      '&:lang(ar)': {
        paddingRight: '0',
      }
    },
  },
  paymentPointsInfo:{
    display: 'flex',
    gap: '5px',
    flexDirection: 'column',
    paddingTop:'20px',
    '@media (min-width: 801px)': {
      paddingTop: '30px'
    },
    '& > div:nth-child(1)': {
      fontSize: '14px',
    },
    fontSize: '13px',
    '& > div:nth-child(2)': {
      '@media (min-width: 801px)': {
        fontSize: '13px'
      }
    },
    '& > div:nth-child(3)': {
      color: '#767676',
      fontSize: '13px',
      '@media (min-width: 801px)': {
        fontSize: '13px'
      }
    }
  },
  reducePadding: {
    paddingTop: '20px',
  },
  paymentPointsInfoExtended:{
    display: 'flex',
    gap: '5px',
    flexDirection: 'column',
    '& > div:nth-child(1)': {
      fontSize: '14px',
    },
    fontSize: '13px',
    '& > div:nth-child(2)': {
      '@media (min-width: 801px)': {
        fontSize: '13px'
      }
    },
    '& > div:nth-child(3)': {
      color: '#767676',
      fontSize: '13px',
      '@media (min-width: 801px)': {
        fontSize: '13px'
      }
    }
  },
  hiddenPaymentPoints: {
    display: 'none',
  },
  noPadding:{},
  noMargin:{},
  title: {
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '10px',
    padding: '10px 15px 0',
    display: 'block',
    '&$noPadding': {
      margin: '0 0 10px',
      padding: '0',
      display: 'block',
      '@media (min-width: 901px)': {
        padding: 0,
        marginBottom: '15px'
      },
      '&$noMargin': {
        marginBottom: 0,
        fontWeight: 500,
        '@media (min-width: 901px)': {
          fontSize: '16px',
          '&:lang(ar)': {
            marginRight: '0',
          }
        },
      },
    },

    '@media (min-width: 901px)': {
      fontSize: '20px',
      fontWeight: '500',
      margin: '0 0 6px 10px',
      display: 'block'
    },
    '&:lang(ar)': {
      '@media (min-width: 901px), print': {
        marginLeft: 0,
        marginRight: '10px'
      }
    },
  },
  starPointsApply: {
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
  },
  blue: {
    accentColor: '#2972B8'
  },
  silver: {
    accentColor: '#A09F9B'
  },
  gold: {
    accentColor: '#B2A16B'
  }
};